<template>
  <modal :show.sync="showModal" id="updateallvalues" size="lg" @close="close">
    <template slot="header">
      <h5 class="modal-title" id="exampleModalLabel">
        Envio de PDF da Condição Comercial
      </h5>
    </template>
    <form ref="form">
      <div class="col-12" style="padding-top: 1rem;">
        <label class="form-control-label">Cargo </label><span style="color:red;"> *</span><br>
        <multiselect
          v-model="filter.role"
          :options="roles"
          label="label"
          track-by="value"
          :multiple="true"
          :limit="1"
          :limit-text="limitText"
          :preserveSearch="true"
          :showNoResults="false"
          placeholder="Selecionar Cargo"
          :key="roles.map(role => role.value).join(',')"
          :close-on-select="false"
          @input="debouncedFilterUsers(null)"
          @select="errorMessages.role = null"
          >
          <template slot="beforeList" class="">
            <div @click="toggleSelectAllRoles"
                 :class="allRoleSelected ? 'all-selected' : 'multiple select-all-option'" :style="allRoleSelected ? 'background-color: #e9ecef; color: #212529' : ''">
              <span :style="allRoleSelected ? 'font-weight: 700' : ''">
                {{ allRoleSelected ? 'desmarcar todos' : 'selecionar todos' }}
              </span>
            </div>
          </template>
        </multiselect>
      </div>
      <div v-if="errorMessages.role" class="invalid-feedback ml-3" style="display: block;">
        {{ errorMessages.role }}
      </div>
      <div class="col-md-12" style="padding-top: 1rem;">
        <label class="form-control-label">Usuários do Sistema</label><span style="color:red;"> *</span><br>
        <multiselect
          v-model="filter.users_emails"
          :options="users"
          :multiple="true"
          :searchable="true"
          :limit="1"
          :limit-text="limitText"
          :loading="isLoadingSalesman"
          placeholder="Selecionar usuários"
          track-by="id"
          label="name"
          @input="errorMessages.users = null"
          @search-change="debouncedFilterUsers"
          :taggable="true"
          @select="errorMessages.users = null"
          :close-on-select="false"
        >
          <template slot="beforeList" class="">
            <div @click="toggleSelectAllUsers" :class="allUsersSelected ? 'all-selected' : 'multiple select-all-option'" :style="allUsersSelected ? 'background-color: #e9ecef; color: #212529' : ''">
              <span :style="allUsersSelected ? 'font-weight: 700' : ''">{{ allUsersSelected ? 'desmarcar todos' : 'selecionar todos' }}</span>
            </div>
          </template>
        </multiselect>
      </div>
      <div v-if="errorMessages.users" class="invalid-feedback ml-3" style="display: block;">
        {{ errorMessages.users }}
      </div>

      <div class="col-md-12" style="padding-top: 1rem;">
        <label class="form-control-label">Usuários Externos</label>
        <tags-input
          v-model="filter.external_emails"
          label="external_users"
          placeholder="Insira um email"
          :rules="validateEmail"
        />
        <div v-if="emailvalidationData" class="invalid-feedback" style="display: block;">
          {{ "Email inválido"}}
        </div>
      </div>
      <div class="col-md-12" style="padding-top: 2rem;">
        <base-button class="mr-3 float-right" type="success" @click="saveEmails" v-loading="isLoadingEmail">Enviar</base-button>
        <base-button  class="mr-3 float-right" type="secondary" @click="close">Fechar</base-button>
      </div>
    </form>
  </modal>
</template>
<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import VueListPicker from "@/components/Vue-list-picker/VueListPicker";
import TagsInput from "@/components/Inputs/TagsInput";
import { Select, Option } from "element-ui";

export default {
  name: "send-pdf-modal",
  components: {
    VueListPicker,
    Multiselect,
    TagsInput,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    commercial: {
      type: Object,
      required: true,
    },
    commercial_brand: {
      required: true,
    },
    brandFilter: Object,
  },
  data() {
    return {
      isLoading: false,
      loadingRoles: false,
      isLoadingSalesman: false,
      users: [],
      filter: {
        users_emails: [],
        external_emails: [],
        role: []
      },
      errorMessages: {
        role: '',
        users: ''
      },
      isLoadingEmail: false,
      roles: [],
      filterUsersTimeout: null,
      allRoleSelectedActive: false,
      allUsersSelectedActive: false,
    };
  },
  mounted() {
    this.getRoles();
    this.clearForm();
    this.clearMessages();

  },
  methods: {
    async getRoles() {
      this.loadingRoles = true;
      try {
        const { data } = await this.$http.secured.get('/api/v1/roles', { params: { per_page: 100 } });
        this.roles = data.roles.map(role => ({
          label: role.name,
          value: role.id
        })) || [];
      } catch (error) {
        console.error("[AvaliationForm][getRoles] Error: ", error);
        this.$toasted.global.defaultError({ msg: "Erro ao carregar a lista de cargos." });
      }
      this.loadingRoles = false;
    },
    toggleSelectAllRoles() {
      if (this.allRoleSelected) {
        this.filter.role = [];
        this.allRoleSelectedActive = false;
      } else {
        this.filter.role = [...this.roles];
        this.allRoleSelectedActive = true;
      }
    },
    toggleSelectAllUsers() {
      if (this.allUsersSelected) {
        this.filter.users_emails = [];
        this.allUsersSelectedActive = false;
      } else {
        this.filter.users_emails = [...this.users];
        this.allUsersSelectedActive = true;
      }
    },
    limitText(count) {
      return `+ ${count}`;
    },
    validateEmail(email) {
      const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return !!email && re.test(email);
    },
    debouncedFilterUsers(name = null) {
      clearTimeout(this.filterUsersTimeout);
      this.filterUsersTimeout = setTimeout(() => {
        this.filterUsers(name);
      }, 500);
    },
    filterUsers(name = null) {
      const selectedRoles = this.filter.role.map(role => role.value);
      if (selectedRoles.length === 0){
        this.users = []; 
        this.filter.users_emails = []; 
        return;
      } 

      let params = { status: true };
      if (selectedRoles.length) params.role_id = selectedRoles;
      if (name) params.name = name;

      this.getUsers(params).then(() => {
        const selectedUsers = this.filter.users_emails.map(selectedUser => {
          return this.users.find(user => user.id === selectedUser.id) || selectedUser;
        });

        this.users = [...selectedUsers, ...this.users.filter(user => !selectedUsers.some(selected => selected.id === user.id))];
      });
    },
    async getUsers(query_params) {
      this.isLoadingSalesman = true;
      const data = { q: query_params, name_only: true };

      try {
        const response = await this.$http.secured.get("/api/v1/users", { params: data });
        this.users = response.data
      } catch (error) {
        console.error("Erro ao buscar usuários:", error);
        this.$toasted.global.defaultError({ msg: "Erro ao carregar a lista de usuários." });
      } finally {
        this.isLoadingSalesman = false;
      }
    },
    requestValidations(){
      this.errorMessages.role = '';
      this.errorMessages.users = '';
      let validationStatus = true;
      if (this.filter.role.length === 0) {
        this.errorMessages.role = 'É necessário selecionar pelo menos um cargo.';
        this.$toasted.global.defaultError({ msg: "Selecione um cargo" });
        validationStatus = false;
      } else if (this.filter.users_emails.length === 0) {
        this.errorMessages.users = 'É necessário selecionar pelo menos um usuário do sistema.';
        this.$toasted.global.defaultError({ msg: "Selecione um usuário" });
        validationStatus = false;
      } else if (!this.commercial.id) {
        this.$toasted.global.defaultError({ msg: "Selecione um período comercial!" });
        validationStatus = false;
      }
      return validationStatus;
    },
    async saveEmails() {
      if (!this.requestValidations()) return;

      const userEmailsRaw = this.filter.users_emails
        .map(user => user && user.email)
        .filter(email => !!email);

      const externalEmailsRaw = this.filter.external_emails.filter(email => !!email);
      const allEmailsRaw = [...userEmailsRaw, ...externalEmailsRaw];
      const seen = new Set();
      const validEmails = [];
      allEmailsRaw.forEach(email => {
        const normalized = email.trim().toLowerCase().replace(/,/g, '.');
        if (this.validateEmail(normalized) && !seen.has(normalized)) {
          seen.add(normalized);
          validEmails.push(normalized);
        }
      });

      if (validEmails.length === 0) {
        this.$toasted.global.defaultError({ msg: "Nenhum email válido encontrado para envio." });
        return;
      }

      this.isLoadingEmail = true;
      try {
        const response = await this.$http.secured.put(`/api/v1/commercials/${this.commercial.id}`, {
          commercial: {
            users_emails: validEmails,
            external_emails: [],
        },
      });
      this.response = response.data;
      await this.sendPdf(validEmails);

      this.$toasted.global.defaultSuccess({ msg: "Operação realizada com sucesso!" });
      this.clearForm();
      this.clearMessages();
      this.showModal = false;
      } catch (error) {
        console.error("[SendPdfModal][saveEmails] Erro completo:", error);
        this.$toasted.global.defaultError({ msg: error.message || "Erro ao enviar o PDF. Tente novamente."});
      } finally {
        this.isLoadingEmail = false;
      }
    },
    async sendPdf(emails) {
      const response = await this.$http.secured.post(`/api/v1/commercials/send_pdf_email`, {
        commercial_id: this.commercial.id,
        role: this.filter.role.map(role => role.value),
        send_email_to: emails,
        commercial_brand_id: this.commercial_brand
      });

      return response;
    },
    clearForm() {
      this.filter = {
        users_emails: [],
        external_emails: [],
        role: []
      };
      this.users = [];
    },
    clearMessages() {
      this.errorMessages = {
        role: '',
        users: ''
      };
    },
    close(){
      this.clearForm();
      this.clearMessages();
      this.showModal = false;
    }
  },
  watch: {
    'filter.role': {
      handler() {
        if (this.filter.role.length > 0) {
          this.debouncedFilterUsers();
        } else {
          this.filter.users_emails = [];
          this.users = [];
          this.allUsersSelected = false;
        }
      },
      immediate: true,
    },
    commercial: {
      handler(val) {
        if (!val.id) return;
      },
      deep: true,
    },
  },
  computed: {
    allRoleSelected() {
      return this.filter.role.length === this.roles.length;
    },
    allUsersSelected: {
      get() {
        return this.filter.users_emails.length === this.users.length;
      },
      set(value) {
        if (value) {
          this.filter.users_emails = this.users.map(user => user.id); //
        } else {
          this.filter.users_emails = [];
        }
      }
    },
    emailvalidationData() {
      return this.filter.external_emails && this.filter.external_emails.some(email => !this.validateEmail(email));
    },
    showModal: {
      get() {
        return this.show;
      },
      set(modal) {
        this.$emit("update:show", modal);
      },
    },
  },
};
</script>
<style lang="scss">
#multiselect {
  padding: 0px;
  display: inline;
}

.el-select {
  width: 100%;
  height: 42px;
  outline: 0;
}
.multiple {
  cursor: pointer;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  height: 30px;
  padding: 12px 10px 30px 12px;
}
.multiple:hover {
  background-color: #41b883;
  color: white;
}
.multiselect__option--highlight {
  background-color: transparent !important;
  color: #35495e;
}
.multiselect__option--selected.multiselect__option--highlight {
  background-color: rgb(239, 241, 244) !important;
  color: #35495e;
}
.multiselect__option:hover {
  background-color: #41b883  !important;
  color: white;
}
.all-selected:hover {
  background-color: #41b883  !important;
  color: white;
  height: 30px;
  padding: 12px 10px 30px 12px;
}
.all-selected {
  height: 30px;
  padding: 12px 10px 30px 12px;
  cursor: pointer;
}
</style>
